module.exports = __webpack_public_path__ + "static/media/logo-grey.d8965388.svg";